export default "__VITE_ASSET__Cprp5YfZ__"